import { TextOld } from '~/components/ui/text';
import { Title, TITLE_TYPE } from '~/components/ui/title';
import { COLORS } from '~/styles/colors';

import image1 from './assets/image1.png';
import image2 from './assets/image2.png';
import image3 from './assets/image3.png';
import image4 from './assets/image4.png';
import Card from './card/Card';
import { StyledCardsWrapper, StyledContainer, StyledTitle, StyledTwoCards } from './styled';

const LIST = [
  [
    {
      id: 1,
      image: image1,
      title: 'On restaurant windows',
      text: 'If your restaurant has physical tables, you can place a Restaurant Menu QR Code on table tents or the menus themselves, allowing customers to access them directly without waiting for the server. This is especially helpful in minimizing contact between the staff and customers for safety purposes.',
    },
    {
      id: 2,
      image: image2,
      title: 'On delivery vehicles',
      text: "Offering a downloadable PDF of your menu is an excellent strategy to boost customer orders when they spot your delivery vehicles. You can create a QR code for your restaurant's menu, which leads to a page where customers can easily place an order online.",
    },
  ],
  [
    {
      id: 3,
      image: image3,
      title: 'On food packaging',
      text: 'QR codes on food packaging are an effective tool for increasing customer loyalty. For instance, you can place a Restaurant Menu QR Code on the packaging and direct users to a landing page where they can access promotions, such as coupons or special discounts for repeat purchases.',
    },
    {
      id: 4,
      image: image4,
      title: 'On restaurant tables',
      text: "A QR code for your restaurant menu provides a safer experience by letting customers view it on their smartphones, reducing contact with physical menus that may carry germs. It's easy to display the code on table tents, windows, or walls for quick access.",
    },
  ],
];

export default function RestaurantMenu() {
  return (
    <StyledContainer>
      <StyledTitle>
        <Title type={TITLE_TYPE.h2} color={COLORS.textMain} center>
          Can I See How a Restaurant Menu QR Code is Used?
        </Title>
      </StyledTitle>
      <TextOld color={COLORS.grey400} fontWeight={400} textAlign="center">
        Here are several creative ways you can make use of a Restaurant Menu QR Code. Below, we&apos;ve gathered some
        ideas to inspire you.
      </TextOld>
      <StyledCardsWrapper>
        {LIST.map((arr, index) => (
          <StyledTwoCards key={index}>
            {arr.map(({ id, image, title, text }) => (
              <Card key={id} image={image} title={title} text={text} />
            ))}
          </StyledTwoCards>
        ))}
      </StyledCardsWrapper>
    </StyledContainer>
  );
}
